import React, { useContext, useState, useEffect } from 'react'
import singlePodcast2 from '../assets/singlepodcast2.png'
import MusicCast from '../assets/MaterialSymbolsMusicCast.png'
import main2 from '../assets/Eventsmainimg2.png'
import { PiMoney } from "react-icons/pi";
import { EventsContext } from '../context/EventsContext'
import { PiGooglePodcastsLogoBold } from "react-icons/pi";
import { FaLocationDot } from "react-icons/fa6";
import { getAppData } from '../apiService';
import { useNavigate } from 'react-router-dom';
import { ShimmerCategoryItem, ShimmerContentBlock, ShimmerSectionHeader, ShimmerText, ShimmerThumbnail, ShimmerTitle } from 'react-shimmer-effects';

function EventsInner() {
  const { allEvenst, setAllEvents, eventId, setEventId, topEvents } = useContext(EventsContext)
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [singleEventDetail, setSingleEventDetail] = useState(null)
  const [dataFetched, setDataFetched] = useState(false);


  //   useEffect(() => {
  //     const fetchData = async () => {
  //       setLoading(true);
  //       // console.log('Fetching data...');
  //       try {
  //         const result = await getAppData('/api.php?set=Events&page=1&offset=5000&uid=1');
  //         if (result.success === 1) {
  //           // console.log(result.result.data, 'fetched data');
  //           setAllEvents(result.result.data);
  //           setDataFetched(true); // Set dataFetched to true after fetching data
  //         }
  //       } catch (err) {
  //         setError('Error fetching data. Please try again later.');
  //         console.error('Error:', err);
  //       } finally {
  //         setLoading(false);
  //         // console.log('Data fetch complete');
  //       }
  //     };

  //     fetchData();
  //   }, [setAllEvents]);

  //   useEffect(() => {
  //     // console.log('useEffect triggered:', allEvenst, eventId, dataFetched);

  //     const myFun = () => {
  //         if (!dataFetched) {
  //             // console.log('Data is not fetched yet.');
  //             return;
  //         }

  //         if (allEvenst && allEvenst.length > 0) {
  //             // console.log('All Events:', allEvenst);
  //             // console.log('Looking for eventId:', eventId);

  //             // Log all event IDs for comparison
  //             allEvenst.forEach((item) => {
  //                 // console.log(`Event ID: ${item.id}`);
  //             });
  //               // console.log(allEvenst.map((item)=>item.id),"important");

  //             const data = allEvenst.find((item) => item.id == eventId);

  //             if (data) {
  //                 // console.log('Event found:', data);
  //                 setSingleEventDetail(data);
  //             } else {
  //                 // console.log('Event not found!');
  //                 setSingleEventDetail(null);  // Ensure null is set when event not found
  //             }
  //         } else {
  //             // console.log('Waiting for data to load or data is empty...');
  //         }
  //     };

  //     myFun();
  // }, [dataFetched, allEvenst, eventId]);     


  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      // console.log('Fetching data...');
      try {
        const result = await getAppData(`/api.php?set=SingleEvent&id=${eventId}`);
        if (result.success === 1) {
          // console.log(result.result.data, 'fetched data');
          setSingleEventDetail(result.data.result);
          // setDataFetched(true); // Set dataFetched to true after fetching data
        }
      } catch (err) {
        setError('Error fetching data. Please try again later.');
        console.error('Error:', err);
      } finally {
        setLoading(false);
        // console.log('Data fetch complete');
      }
    };

    if (eventId) {
      fetchData();
    } else {
      navigate("/events")
    }
  }, [eventId]);

  const morePodcasts = [
    { id: "ojfewi1", image: `${singlePodcast2}`, heading: "Premium story", author: "James Hoyce" },
    { id: "ojfewi2", image: `${singlePodcast2}`, heading: "Premium story", author: "James Hoyce" },
    { id: "ojfewi3", image: `${singlePodcast2}`, heading: "Premium story", author: "James Hoyce" },
    { id: "ojfewi4", image: `${singlePodcast2}`, heading: "Premium story", author: "James Hoyce" },
  ]

  // const recentPlayed = [
  //   {id:"fgewqy1",image:`${MusicCast}`, heading: "Premium story", author: "James Hoyce"},
  //   {id:"fgewqy2",image:`${MusicCast}`, heading: "Premium story", author: "James Hoyce"},
  //   {id:"fgewqy3",image:`${MusicCast}`, heading: "Premium story", author: "James Hoyce"},
  // ]
  // const recentPlayedforPhone = [
  //   {id:"fgewqy1",image:`${MusicCast}`, heading: "Premium story", author: "James Hoyce"},
  //   {id:"fgewqy2",image:`${main2}`, heading: "Premium story", author: "James Hoyce"},
  //   {id:"fgewqy3",image:`${MusicCast}`, heading: "Premium story", author: "James Hoyce"},
  //   {id:"fgewqy3",image:`${main2}`, heading: "Premium story", author: "James Hoyce"},
  // ]


  if (loading) {
    return (
      <div className="layout6-div">
        <div className="Main-div-with-three-main-content-divs-in-events">
          <div className='Main-inner-more-podcasts-in-events'>
            <div className='main-inner-more-podcast-inside-content-for-more-podcasts123456789'>
              <ShimmerCategoryItem
                hasImage
                imageType="thumbnail"
                imageWidth={100}
                imageHeight={100}
                text
              />
            </div>
            <div className='main-inner-more-podcast-inside-content-for-more-podcasts123456789'>
              <ShimmerCategoryItem
                hasImage
                imageType="thumbnail"
                imageWidth={100}
                imageHeight={100}
                text
              />
            </div>
            <div className='main-inner-more-podcast-inside-content-for-more-podcasts123456789'>
              <ShimmerCategoryItem
                hasImage
                imageType="thumbnail"
                imageWidth={100}
                imageHeight={100}
                text
              />
            </div>

            <hr className='main-inner-recently-played-hr' />
            {/* <ShimmerSectionHeader />                                                              check on monday  */}
            <div className='main-inner-only-for-phone-screen-recently-played-text1234567890'>

              <ShimmerTitle line={1} gap={10} />
            </div>
            <div className='main-inner-only-for-phone-screen-recently-played-text1234567890'>
              <ShimmerText line={3} gap={10} />
            </div>

          </div>
          <div className='Main-inner-all-events-image-will-displayed-here'>
            <div className='Main-inner-all-events-image-will-displayed-her'>
              <p className='main-inner-for-mobile-all-events-image-text'>Local Play</p>
              <ShimmerThumbnail height={450} rounded />
              <div>
                <ShimmerText line={3} gap={10} />
              </div>
            </div>
          </div>
          <div className='main-inner-all-events-main-div-of-all-social-events-outer-div'>
            <ShimmerCategoryItem
              hasImage
              imageType="thumbnail"
              imageWidth={100}
              imageHeight={100}
              text
            /><ShimmerCategoryItem
              hasImage
              imageType="thumbnail"
              imageWidth={100}
              imageHeight={100}
              text
            /><ShimmerCategoryItem
              hasImage
              imageType="thumbnail"
              imageWidth={100}
              imageHeight={100}
              text
            />
          </div>
          <div className='main-inner-only-for-phone-screen-recently-played'>
            <ShimmerText line={5} gap={10} />
          </div>
          <div className='Main-inner-recently-played-podcasts-in-events'>
            <p className='main-inner-recently-played-main-heading'>Top Events</p>
            <hr className='main-inner-recently-played-hr' />
            {/* {recentPlayed.map((item)=>( */}
            <div className='main-inner-recently-played-all-recently-played-here-123'>
              <div className='main-inner-recently-played-all-recently-played-here1'>
                <ShimmerContentBlock
                  title
                  text
                  cta
                  thumbnailWidth={170}
                  thumbnailHeight={170}
                  style={{ marginBottom: "10px" }}
                />
              </div>
              <div className='main-inner-recently-played-all-recently-played-here1'>
                <ShimmerContentBlock
                  title
                  text
                  cta
                  thumbnailWidth={170}
                  thumbnailHeight={170}
                  style={{ marginBottom: "10px" }}
                />
              </div>
              <div className='main-inner-recently-played-all-recently-played-here1'>
                <ShimmerContentBlock
                  title
                  text
                  cta
                  thumbnailWidth={170}
                  thumbnailHeight={170}
                  style={{ marginBottom: "10px" }}
                />
              </div>
            </div>
          </div>

        </div>
      </div>
    );
  }

  if (error) {
    return (
      <>
        <div className="blur-background"></div>
        <div className="error-container">
          <p>{error}</p>
        </div>
      </>
    )
  }
  if (!singleEventDetail) {
    return <div>Loading event details...</div>; // Or handle accordingly
  }
  return (
    <>
      {/* {allEvenst.length>0? */}
      <div className='layout6-div'>
        <div className='Main-div-with-three-main-content-divs-in-events'>
          <div className='Main-inner-more-podcasts-in-events'>
            {/* {morePodcasts.map((item)=>( */}
            <div className='main-inner-more-podcasts-all-more-podcast-here'>
              <div className='main-inner-more-podcast-inside-content-for-more-podcasts'>
                <div className='Main-inner-more-icons-for-event-single'>
                  <PiMoney />
                </div>
                <div className='main-inner-more-podcast-inside-paras-for-more-podcasts'>
                  <p className='main-inner-more-podcast-para1'>Event Fee</p>
                  {console.log(singleEventDetail,"title")
                  }
                  <p className='main-inner-more-podcast-para2'>${singleEventDetail.event_fee}</p>
                </div>
              </div>
            </div>
            <div className='main-inner-more-podcasts-all-more-podcast-here'>
              <div className='main-inner-more-podcast-inside-content-for-more-podcasts'>
                <div className='Main-inner-more-icons-for-event-single'>
                  {/* <p style={{width:"100%",backgroundColor:"black",color:"#fff",textAlign:"center"}}>{singleEventDetail.event_date.slice(0, 3).toUpperCase()}</p> */}
                  <p style={{ width: "100%", backgroundColor: "black", color: "#fff", textAlign: "center" }}>{(
                    () => {
                      const dateString = singleEventDetail.event_date;

                      const [day, month, year] = dateString.split('-');
                      const months = [
                        "January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"
                      ];
                      const monthName = months[parseInt(month) - 1];
                      return monthName.slice(0, 3).toUpperCase();
                    })()}</p>
                  <div>{
                    (() => {
                      let dateString = singleEventDetail.event_date;
                      let date = dateString.match(/\d+/);
                      date = date ? parseInt(date[0]) : null;
                      return date;
                    })()
                  }</div>
                </div>
                <div className='main-inner-more-podcast-inside-paras-for-more-podcasts'>
                  <p className='main-inner-more-podcast-para1' style={{ fontWeight: "600" }}>{singleEventDetail.event_date}</p>
                  <p className='main-inner-more-podcast-para2'>{singleEventDetail.event_start_time} to {singleEventDetail.event_end_time}</p>
                </div>
              </div>
            </div>
            <div className='main-inner-more-podcasts-all-more-podcast-here'>
              <div className='main-inner-more-podcast-inside-content-for-more-podcasts'>
                <div className='Main-inner-more-icons-for-event-single'>
                  <FaLocationDot />
                </div>
                <div className='main-inner-more-podcast-inside-paras-for-more-podcasts'>
                  <p className='main-inner-more-podcast-para1' style={{ fontWeight: "600" }}>{singleEventDetail.event_location}</p>
                  <p className='main-inner-more-podcast-para2'>{singleEventDetail.event_location}</p>
                </div>
              </div>
            </div>
            {/* ))} */}
            <hr className='main-inner-recently-played-hr' />
            <p className='main-inner-only-for-phone-screen-recently-played-text1'>Event Details</p>
            <p className='main-inner-recently-played-all-recently-played-here-hyuih1'>{singleEventDetail.description}</p>
          </div>
          <div className='Main-inner-all-events-image-will-displayed-here'>
            <div className='Main-inner-all-events-image-will-displayed-her'>
              <p className='main-inner-for-mobile-all-events-image-text'>Local Play</p>
              {/* {allEvenst.map((item)=>( */}
              <>
                <div className='main-inner-all-events-main-div-of-all-images' key={singleEventDetail.id}>
                  <img src={singleEventDetail.image} alt="eventmainimage" className='main-inner-all-events-main-div-of-single-image' />
                </div>
                {/* <p className='main-inner-all-events-main-div-of-all-heading'>{item.heading}</p>
              <div className='main-inner-all-events-main-div-of-all-date-and-time'><p>{item.time}</p> <p>{item.date}</p></div> */}
              </>
              {/* ))} */}
            </div>

            <div className='EventsInner-main-other'>
              <p>{singleEventDetail.event_start_time.slice(0, 7)}</p>
              {/* <p><span style={{marginRight:"15px"}}>.</span>{singleEventDetail.event_location.split(",")[1].trim()}</p> */}
              <p><span style={{ marginRight: "15px" }}>.</span>{singleEventDetail.event_location}</p>
              <p><span style={{ marginRight: "15px" }}>.</span>${singleEventDetail.event_fee}</p>
            </div>
            <div className='EventsInner-main-other2'>
              <p>{singleEventDetail.title}</p>
            </div>
            {/* <ul className='EventsInner-main-other3'>
    <li>App Dev Community Event</li>
</ul> */}
          </div>


          <div className='main-inner-all-events-main-div-of-all-social-events-outer-div'>
            <div className='main-inner-more-podcasts-all-more-podcast-here'>
              <div className='main-inner-more-podcast-inside-content-for-more-podcasts'>
                <div className='Main-inner-more-icons-for-event-single'>
                  <PiMoney />
                </div>
                <div className='main-inner-more-podcast-inside-paras-for-more-podcasts'>
                  <p className='main-inner-more-podcast-para1'>Event Fee</p>
                  <p className='main-inner-more-podcast-para2'>${singleEventDetail.event_fee}</p>
                </div>
              </div>
            </div>
            <div className='main-inner-more-podcasts-all-more-podcast-here'>
              <div className='main-inner-more-podcast-inside-content-for-more-podcasts'>
                <div className='Main-inner-more-icons-for-event-single'>
                  <p style={{ width: "100%", backgroundColor: "black", color: "#fff", textAlign: "center" }}>{(
                    () => {
                      const dateString = singleEventDetail.event_date;

                      const [day, month, year] = dateString.split('-');
                      const months = [
                        "January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"
                      ];
                      const monthName = months[parseInt(month) - 1];
                      return monthName.slice(0, 3).toUpperCase();
                    })()}</p>
                  <div>{
                    (() => {
                      let dateString = singleEventDetail.
                        event_date;
                      let date = dateString.match(/\d+/);
                      date = date ? parseInt(date[0]) : null;
                      return date;
                    })()
                  }</div>
                </div>
                <div className='main-inner-more-podcast-inside-paras-for-more-podcasts'>
                  <p className='main-inner-more-podcast-para1' style={{ fontWeight: "600" }}>{singleEventDetail.event_date}</p>
                  <p className='main-inner-more-podcast-para2'>{singleEventDetail.event_start_time} to {singleEventDetail.event_end_time}</p>
                </div>
              </div>
            </div>
            <div className='main-inner-more-podcasts-all-more-podcast-here'>
              <div className='main-inner-more-podcast-inside-content-for-more-podcasts'>
                <div className='Main-inner-more-icons-for-event-single'>
                  <FaLocationDot />
                </div>
                <div className='main-inner-more-podcast-inside-paras-for-more-podcasts'>
                  <p className='main-inner-more-podcast-para1' style={{ fontWeight: "600" }}>{singleEventDetail.event_location}</p>
                  <p className='main-inner-more-podcast-para2'>{singleEventDetail.event_location}</p>
                </div>
              </div>
            </div>
          </div>

          <div className='main-inner-only-for-phone-screen-recently-played'>
            <p className='main-inner-only-for-phone-screen-recently-played-text'>Event Details</p>
            <div className='main-inner-only-for-phone-screen-recently-played-main-content'>
              <p>{singleEventDetail.description
              }</p>
              {/* {recentPlayedforPhone.map((item)=>( */}
              {/* <div className='main-inner-recently-played-all-recently-played-here'>
             <div className='main-inner-recently-played-inside-content-for-recently-played'>
               <img className='main-inner-more-recently-played-image-for-recently-played' src={item.image} alt="singlePodcast" />
               <div className='main-inner-more-recently-played-paras-for-recently-played'>
                 <p className='main-inner-recently-played-para1'>{item.heading}</p>
                 <p className='main-inner-recently-played-para2'>{item.author}</p>
               </div>
             </div>
           </div> */}
              {/* ))} */}
            </div>
            <div>

            </div>
          </div>
          <div className='Main-inner-recently-played-podcasts-in-events'>
            <p className='main-inner-recently-played-main-heading'>Top Events</p>
            <hr className='main-inner-recently-played-hr' />
            {/* {recentPlayed.map((item)=>( */}
            <div className='main-inner-recently-played-all-recently-played-here-123'>



              {topEvents.map((item) => (
                <div className='main-inner-more-podcasts-all-more-podcast-here-123' key={item.id} onClick={() => { setEventId(item.id); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
                  <div className='main-inner-more-podcast-inside-content-for-more-podcasts-123'>
                    <div className='main-inner-more-podcast-inside-image-for-more-podcasts-123'>
                      <img src={item.image} alt="singlePodcast" style={{ width: "100%", height: "100%" }} />
                    </div>
                    <div className='main-inner-more-podcast-inside-paras-for-more-podcasts-123'>
                      <p className='main-inner-more-podcast-para1-123'>{item.title}</p>

                    </div>
                  </div>
                  <hr className='main-inner-recently-played-hr-all' />
                </div>
              ))}





              {/* <div className='main-inner-recently-played-inside-content-for-recently-played'>
               <img className='main-inner-more-recently-played-image-for-recently-played' src={item.image} alt="singlePodcast" />
               <div className='main-inner-more-recently-played-paras-for-recently-played'>
                 <p className='main-inner-recently-played-para1'>{item.heading}</p>
                 <p className='main-inner-recently-played-para2'>{item.author}</p>
               </div>
             </div>
             <hr /> */}
            </div>
            {/* ))} */}
          </div>

        </div>

      </div>
      {/* :<div className='layout6-div' style={{color:"#fff"}}>data not found</div>} */}
    </>
  )
}

export default EventsInner